<div class="col-xs-5 col-md-5 col-centered col-slider no-padding row">
  <h1>Тариф</h1>
  <transport-tariff-form [tariff]="tariff" (onSubmit)="onSubmit()"></transport-tariff-form>
</div>
